import React from 'react'
import "./footer.css"


const Footer = () => {
    return (
        <footer className='footer'>
            <div className='footer__container container'>
                <h1 className='footer__title'>Afshan</h1>

                <ul className='footer__list'>
                    <li>
                        <a href="#about" className='footer__link'>About</a>
                    </li>

                    <li>
                        <a href="#portfolio" className='footer__link'>Projects</a>
                    </li>

                    <li>
                        <a href="#testimonials" className='footer__link'>Testimonials</a>
                    </li>
                </ul>
                <div className='footer__social'>
                    <a href="https://www.facebook.com/mrafshankhan?mibextid=ZbWKwL" className='footer__social-link' target='_blank'>
                        <i class="bx bxl-facebook"></i>
                    </a>
                    <a href="https://www.instagram.com/king_of_khans_06?igsh=OGQ5ZDc2ODk2ZA==" className='footer__social-link' target='_blank'>
                        <i class="bx bxl-instagram"></i>
                    </a>
                    <a href="https://x.com/Afshankhan_07?t=JyI-ogdm7aRhyjTLcIwGoA&s=09" className='footer__social-link' target='_blank'>
                        <i class="bx bxl-twitter"></i>
                    </a>
                </div>

                <span className='footer__copy'>
                    &#5719; AfshanKhan. All rights reserved
                </span>
            </div>
        </footer>
    )
}

export default Footer